import React, { useState, useCallback, useRef, useEffect } from "react";
import {
  DatePicker,
  DateTimePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import {
  TextInput,
  Create,
  SimpleForm,
  Toolbar,
  required,
  SaveButton,
  ArrayInput,
  SelectInput,
  DateInput,
  NumberInput,
  minLength,
  maxLength,
  number,
} from "react-admin";
import Select from "react-select";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import AddPlusIcon from "../../src/images/add-plus.svg";
import RemoveMinusIcon from "../../src/images/remove-minus.svg";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const DiscountSchemesCreate = ({ permissions, ...props }) => {
  const navigate = useNavigate();
  const [schemeName, setSchemeName] = useState("");
  const [schemeNameError, setSchemeNameError] = useState(false);
  const [noOfCoupons, setNoOfCoupons] = useState("");
  const [noOfCouponsError, setNoOfCouponsError] = useState(false);
  let tomDate = new Date();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(
    new Date(tomDate.setDate(tomDate.getDate() + 1))
  );
  const [discountValue, setDiscountValue] = useState("");
  const [discountType, setDiscountType] = useState("");
  const [discountSchemeType, setDiscountSchemeType] = useState("");
  const [discountValueError, setDiscountValueError] = useState(false);
  const [fieldsNumError, setFieldsNumError] = useState(false);
  const [couponCode,setCouponCode] = useState("");
  const [couponCodeError, setCouponCodeError] = useState(false);

  const [choiceList, setChoiceList] = useState([
    { inputType: "text", value: "by_quantity", label: "Quantity" },
    { inputType: "text", value: "by_sales_amount", label: "Sales amount" },
    {
      inputType: "select",
      value: "by_product_combinations",
      label: "Product Combinations",
    },
    {
      inputType: "select",
      value: "by_delivery_mode",
      label: "Delivery Mode",
    },
    {
      inputType: "select",
      value: "by_customer_segment_type",
      label: "Customer Segment Type",
    },
    { inputType: "select", value: "by_product", label: "Product" },
    // { inputType: "select", value: "by_location", label: "Location" },
  ]);

  const [fields, setFields] = useState([
    // { condition_value: "", condition_type: "" }, // Initialize the state with an empty input and a default selected option
  ]);

  console.log("drippppppppppp", choiceList, fields);

  const [choiceCompareList, setChoiceCompareList] = useState([
    { inputType: "text", value: "by_quantity", label: "Quantity" },
    { inputType: "text", value: "by_sales_amount", label: "Sales Amount" },
    {
      inputType: "select",
      value: "by_product_combinations",
      label: "Product Combinations",
    },
    {
      inputType: "select",
      value: "by_delivery_mode",
      label: "Delivery Mode",
    },
    {
      inputType: "select",
      value: "by_customer_segment_type",
      label: "Customer Segment Type",
    },
    { inputType: "select", value: "by_product", label: "Product" },
    // { inputType: "select", value: "by_location", label: "Location" },
  ]);

  const [loader, setLoader] = useState(false);

  const [selectConditionOption, setSelectConditionOption] = useState({});

  React.useEffect(() => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/fetch_condition_suggestions`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        const data = jsonD;
        let modifiedByProduct = data.by_product.map((data) => {
          return { value: data.value, label: `${data.label} (${data.value})` };
        });
        data.by_product = modifiedByProduct;
        let modifiedByProductCombination = data.by_product_combinations.map(
          (data) => {
            return {
              value: data.value,
              label: `${data.label} (${data.value})`,
            };
          }
        );
        data.by_product_combinations = modifiedByProductCombination;
        console.log("jsonD ===> fetch_condition_suggestions", jsonD, data);
        setSelectConditionOption(data);
      });
  }, []);

  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleAddField = (e) => {
    e.preventDefault();
    setFields([...fields, { condition_value: "", condition_type: "" }]);
    let result = choiceList.filter(
      (o1) => !fields.some((o2) => o1.value === o2.condition_type)
    );
    setChoiceList(result);

    console.log("fieldssssssssssss", fields);
  };

  const handleRemoveField = (e, currentData, index) => {
    e.preventDefault();
    console.log(
      "................................................",
      currentData,
      index
    );
    const newFields = [...fields];
    const compareFields = [...fields];

    newFields.splice(index, 1);
    setFields(newFields);

    if (currentData.condition_type !== "") {
      let missingObjectArray = choiceCompareList.filter(
        (e) => !choiceList.find((a) => e.value === a.value)
      );
      const indexs = choiceCompareList.findIndex((item) =>
        item.value == missingObjectArray.length
          ? missingObjectArray[0].value
          : ""
      );

      // let missingObject = choiceCompareList.filter(e => e.value === compareFields[index].value)
      let missingObject = missingObjectArray.filter(
        (e) => e.value == compareFields[index].condition_type
      );
      console.log(
        "missssssssssssssss",
        missingObjectArray,
        choiceList,
        newFields,
        missingObjectArray.filter(
          (e) => e.value == compareFields[index].condition_type
        ),
        fields
      );

      let newList = [...choiceList];
      newList.splice(indexs, 0, ...missingObject);

      // setChoiceList([...missingObjectArray,...choiceList])
      setChoiceList(newList);
    }
    // console.log('missingObject', choiceList, indexs);
  };

  const handleInputChange = (index, e) => {
    e.preventDefault();
    let { value } = e.target;
    if (
      value != "" ||
      value != undefined ||
      value != null ||
      !value.trim().length
    ) {
      const newFields = [...fields];
      if (!(value < 1)) {
        newFields[index].condition_value = value;
        setFields(newFields);
        setFieldsNumError(false);
      } else {
        newFields[index].condition_value = null;
        setFields(newFields);
        setFieldsNumError(true);
      }
    }
  };

  function isFirstObjectEmpty(arr) {
    if (arr.length === 0) {
      return false; // Array is empty, no objects to check
    }

    const firstObject = arr[0];

    for (const key in firstObject) {
      if (Object.prototype.hasOwnProperty.call(firstObject, key)) {
        const value = firstObject[key];

        if (value === null || value === undefined || value === "") {
          return true; // Found an empty value
        }
      }
    }

    return false; // No empty values found
  }

  console.log(
    "kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk",
    fields,
    fields.length < 1,
    isFirstObjectEmpty(fields)
  );

  const handleSelectChange = (index, value) => {
    console.log("handleInputChange handleInputChange", value, index, fields);

    console.log(
      "iiiiiiiiiiiiiiiiiiiiiiiii",
      choiceList,
      value == "by_product_combinations",
      value == "by_product"
    );
    const newFields = [...fields];
    newFields[index].condition_type = value;
    setFields(newFields);
  };

  const CreateToolbar = (props) => {
    return (
      <Toolbar {...props}>
        <SaveWithNoteButton {...props} />
      </Toolbar>
    );
  };

  const SaveWithNoteButton = (props) => {
    const { history } = props;
    let finalized = null;
    const handleSave = (e, props) => {
      e.preventDefault();
      let dataToSend = {
        scheme_name: schemeName,
        no_of_coupons: noOfCoupons,
        start_datetime: startDate,
        end_datetime: endDate,
        discount_type: discountType,
        discount_value: discountValue,
        is_finalized: props,
        status: true,
        discount_scheme_conditions: [...fields],
        coupon_code:couponCode.replace(/ /g, ''),
        discount_scheme_type:discountSchemeType,
      };

      const options = CommonHeaderOption();
      const apiUrl = RUN_TIME_API_ENDPOINT;
      options.method = "POST";
      options.body = JSON.stringify(dataToSend);
      fetch(`${apiUrl}/discount_schemes`, options)
      .then((res) => {
        if (res.ok) return res.json();
        return res.json().then(res => {
          throw new Error(res.errors.status)
        })
      })
        .then((json) => {
          if (json) {
            console.log("json reply", json, props, history);
            if (json.is_finalized) {
              if (discountSchemeType =="static" ) {
                navigate(`/discount_schemes/${json.id}/show`);
              }else{
                navigate(`/discount_scheme_assignment/${json.id}`, {
                  id: json.id,
                });
              }
            } else {
              navigate(`/discount_schemes/${json.id}/show`);
            }

          }
        }).catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error,
          });
          console.log(error);
        });

      // console.log("zz ", fields, dataToSend);
    };
    // set onSave props instead of handleSubmitWithRedirect
    return loader ? (
      <div className="save-loader" />
    ) : (
      <>
        <SaveButton
          type="button"
          label="save as draft"
          disabled={
            !schemeName ||
            discountSchemeType =="static" && !couponCode || 
            discountSchemeType =="dynamic" &&!noOfCoupons ||
            !discountValue ||
            !discountType ||
            fields.length < 1 ||
            isFirstObjectEmpty(fields) ||
            moment(endDate).isBefore(startDate)
          }
          {...props}
          onClick={(e) => handleSave(e, (finalized = false))}
        />
        <div className="finalize-btn">
          <SaveButton
            type="button"
            label="finalize"
            disabled={
              !schemeName ||
              discountSchemeType =="static" && !couponCode || 
              discountSchemeType =="dynamic" && !noOfCoupons ||
              !discountValue ||
              !discountType ||
              fields.length < 1 ||
              isFirstObjectEmpty(fields) ||
              moment(endDate).isBefore(startDate)
            }
            {...props}
            onClick={(e) => handleSave(e, (finalized = true))}
          />
        </div>
      </>
    );
  };

  const capitalizeEachWord = (str) => {
    const words = str.replace(/_/g, " ").split(" ").slice(1);
    const capitalizedWords = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return capitalizedWords.join(" ");
  };

  const checkPreviousElement = (fields) => {
    if (fields.length < 0) return false;
    if (fields.length && fields[fields.length - 1].condition_value == "")
      return false;
    return true;
  };

  return (
    <Create mutationMode="pessimistic" {...props}>
      <SimpleForm toolbar={<CreateToolbar {...props} />}>
        <div className="so-input scheme-name-input">
          <label>
            Scheme name<sup className="asterisk">*</sup>
          </label>
          <TextInput
            className="promotion-title-input"
            source="scheme_name"
            value={schemeName}
            onChange={(e) => {
              if (
                e.target.value != "" ||
                e.target.value != undefined ||
                e.target.value != null ||
                !e.target.value.trim().length
              ) {
                console.log("opppppppppppppppppp", e.target.value);
                if (
                  !(e.target.value.length > 200 || e.target.value.length < 1)
                ) {
                  setSchemeName(e.target.value);
                  setSchemeNameError(false);
                } else {
                  setSchemeName("");
                  setSchemeNameError(true);
                }
              }
            }}
          />
          {schemeNameError && (
            <p className="so-input-error">
              Please enter name below 200 characters{" "}
            </p>
          )}
        </div>
        <div className="tf-item2">
          <div className="so-input discount-item">
            <label>
            Discount scheme type<sup className="asterisk">*</sup>
            </label>
            <select
              className="inapp-notification-sendto"
              name="discount_scheme_type"
              value={discountSchemeType}
              onChange={(e) => {
                if (
                  e.target.value != "" ||
                  e.target.value != undefined ||
                  e.target.value != null ||
                  !e.target.value.trim().length
                ) {
                  setDiscountSchemeType(e.target.value);
                }
              }}
            >
              <option value="">Select Option</option>
              <option value="static">Static</option>
              <option value="dynamic">Dynamic</option>
            </select>
          </div>
        </div>
        <div className="row-align-top">
          {
          discountSchemeType =="dynamic" &&
            <div className="so-input input-item">
              <label>
                No of coupons<sup className="asterisk">*</sup>
              </label>
              <NumberInput
                className="promotion-title-input"
                max="100"
                min="1"
                validate={[minLength(1), maxLength(100), number()]}
                source="no_of_coupons"
                value={noOfCoupons}
                onChange={(e) => {
                  if (
                    e.target.value != "" ||
                    e.target.value != undefined ||
                    e.target.value != null ||
                    !e.target.value.trim().length
                  ) {
                    if (!(e.target.value > 500 || e.target.value < 1)) {
                      setNoOfCoupons(e.target.value);
                      setNoOfCouponsError(false);
                    } else {
                      setNoOfCoupons("");
                      setNoOfCouponsError(true);
                    }
                  }
                }}
              />
              {noOfCouponsError && (
                <p className="so-input-error">
                  Please enter a min 1 and max 500{" "}
                </p>
              )}
            </div>
          }

          {
            discountSchemeType =="static" &&
            <div className="so-input input-item">
            <label>
            Coupon code<sup className="asterisk">*</sup>
            </label>
            <TextInput
              className="promotion-title-input"
              source="coupon_code"
              onKeyDown={(e)=>{
                if(e.code === 'Space'){e.preventDefault()}
              }}
              value={couponCode}
              onChange={(e) => {
                if (
                  e.target.value != "" ||
                  e.target.value != undefined ||
                  e.target.value != null ||
                  !e.target.value.trim().length
                ) {
                  console.log("opppppppppppppppppp", e.target.value);
                  if (
                    !(e.target.value.length > 20 || e.target.value.length < 3)
                  ) {
                    setCouponCode(e.target.value);
                    setCouponCodeError(false);
                  } else {
                    setCouponCode("");
                    setCouponCodeError(true);
                  }
                }
              }}
            />
            {couponCodeError && (
              <p className="so-input-error">
                Please enter coupon code below 20 characters{" "} and above 3 characters
              </p>
            )}
            </div>
          }
          <div className="so-input input-item">
            <label>
              Start Date and Time<sup className="asterisk">*</sup>
            </label>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <DateTimePicker
                value={startDate}
                disablePast
                onChange={(e) => setStartDate(e)}
                format="DD/MM/YYYY hh:mm a"
                // minDate={startDate}
              />
            </MuiPickersUtilsProvider>
            {moment(endDate).isBefore(startDate) && (
              <p className="so-input-error">
                Date should not be before minimal date
              </p>
            )}
          </div>
          <div className="so-input input-item">
            <label>
              End Date and Time<sup className="asterisk">*</sup>
            </label>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <DateTimePicker
                value={endDate}
                disablePast
                onChange={(e) => setEndDate(e)}
                format="DD/MM/YYYY hh:mm a"
                // minDate={startDate}
              />
            </MuiPickersUtilsProvider>
          </div>
        </div>
        <div className="tf-item2">
          <div className="so-input discount-item">
            <label>
              Discount type<sup className="asterisk">*</sup>
            </label>
            <select
              className="inapp-notification-sendto"
              name="type"
              value={discountType}
              onChange={(e) => {
                if (e.target.value == "Amount") {
                  setDiscountValueError(false);
                }
                if (
                  e.target.value != "" ||
                  e.target.value != undefined ||
                  e.target.value != null ||
                  !e.target.value.trim().length
                ) {
                  setDiscountType(e.target.value);
                }
              }}
            >
              <option value="">Select Option</option>
              <option value="%">%</option>
              <option value="Amount">Amount (PHP)</option>
            </select>
          </div>
          <div className="so-input discount-item">
            <label>
              Discount value<sup className="asterisk">*</sup>
            </label>
            <div className="discount-value-input">
              {
                // discountType != ''?
                discountType == "%" ? (
                  <NumberInput
                    className="promotion-title-input"
                    disabled={discountType == ""}
                    max="100"
                    min="1"
                    validate={[minLength(1), maxLength(100), number()]}
                    source="discount_value"
                    value={discountValue}
                    onChange={(e) => {
                      console.log(
                        " e.target.value",
                        e.target.value,
                        !discountValue
                      );
                      if (
                        e.target.value != "" ||
                        e.target.value != undefined ||
                        e.target.value != null ||
                        !e.target.value.trim().length
                      ) {
                        if (!(e.target.value >= 100 || e.target.value < 1)) {
                          setDiscountValue(e.target.value);
                          setDiscountValueError(false);
                        } else {
                          setDiscountValue("");
                          setDiscountValueError(true);
                        }
                      }
                    }}
                  />
                ) : (
                  <NumberInput
                    className="promotion-title-input"
                    source="discount_value"
                    max="100"
                    min="1"
                    validate={[minLength(1), maxLength(100), number()]}
                    disabled={discountType == ""}
                    value={discountValue}
                    onChange={(e) => {
                      if (
                        e.target.value != "" ||
                        e.target.value != undefined ||
                        e.target.value != null ||
                        !e.target.value.trim().length
                      ) {
                        if (!(e.target.value > 15000 || e.target.value < 1)) {
                          setDiscountValue(e.target.value);
                          setDiscountValueError(false);
                        } else {
                          setDiscountValue("");
                          setDiscountValueError(true);
                        }
                      }
                    }}
                  />
                )
                // : null
              }
            </div>
            {discountValueError && (
              <p className="so-input-error">
                Please enter a min 1 and max{" "}
                {discountType == "%" ? "99" : "15000"}{" "}
              </p>
            )}
          </div>
        </div>

        <div className="so-input">
          <label>
            Scheme Conditions<sup className="asterisk">*</sup>
          </label>
          <div>
            {fields.map((field, index) => {
              return (
                <div className="tf-item">
                  {field.condition_type == "" && (
                    <select
                      className="inapp-notification-sendto"
                      value={fields.condition_type}
                      onChange={(e) =>
                        handleSelectChange(index, e.target.value)
                      }
                    >
                      <option value="" selected disabled hidden>
                        Choose condition
                      </option>
                      {choiceList.map((choice) => {
                        // console.log('option listtt', choiceList, choiceList.some(e => e.value == 'by_product'));
                        return (
                          <option
                            disabled={
                              (!choiceList.some(
                                (e) => e.value == "by_product"
                              ) &&
                                choice.value == "by_product_combinations") ||
                              (!choiceList.some(
                                (e) => e.value == "by_product_combinations"
                              ) &&
                                choice.value == "by_product")
                            }
                            style={{
                              display:
                                (!choiceList.some(
                                  (e) => e.value == "by_product"
                                ) &&
                                  choice.value == "by_product_combinations") ||
                                (!choiceList.some(
                                  (e) => e.value == "by_product_combinations"
                                ) &&
                                  choice.value == "by_product")
                                  ? "none"
                                  : "block",
                            }}
                            value={choice.value}
                          >
                            {choice.label}
                          </option>
                        );
                      })}
                    </select>
                  )}
                  {/* <input
                                type="text"
                                value={field.condition_type}
                                disabled
                            /> */}
                  {
                    <div className="tf-selected">
                      {capitalizeEachWord(field.condition_type)}
                      {field.condition_type == "by_quantity" && `(Bags)`}
                      {field.condition_type == "by_sales_amount" && `(PHP)`}
                    </div>
                  }
                  <div className="tf-item2" key={index}>
                    {field.condition_type != "" ? (
                      field.condition_type == "by_quantity" ||
                      field.condition_type == "by_sales_amount" ? (
                        <>
                          <div>
                            <input
                              className="tf-input"
                              type="number"
                              max="100"
                              min="1"
                              disabled={field.condition_type == ""}
                              value={field.condition_value}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </div>
                        </>
                      ) : selectConditionOption ? (
                        field.condition_type == "by_product_combinations" ? (
                          <Select
                            className="tf-multi-select"
                            isMulti
                            // value={selectedOptions}
                            value={field.condition_value}
                            onChange={(event) => {
                              console.log("multiiiiiiiiiii", event);
                              setSelectedOptions(event);
                              const newFields = [...fields];
                              newFields[index].condition_value = event;
                              console.log(
                                "setSelectedOptions(selectedOptions);",
                                selectedOptions
                              );
                            }}
                            options={
                              selectConditionOption[field.condition_type]
                            }
                          />
                        ) : (
                          <Select
                            className="tf-multi-select"
                            value={{
                              value: field.condition_value.value,
                              label: field.condition_value.label,
                            }}
                            onChange={(event) => {
                              const newFields = [...fields];
                              console.log(
                                "onchange hai select",
                                event,
                                field.condition_type
                              );
                              newFields[index].condition_value = event;
                              setFields(newFields);
                            }}
                            options={
                              selectConditionOption[field.condition_type]
                            }
                          />
                        )
                      ) : null
                    ) : null}
                    {field.condition_type != "" && (
                      <button
                        className="tf-btn"
                        onClick={(e) => handleRemoveField(e, field, index)}
                      >
                        <img
                          className="add-remove-icon"
                          src={RemoveMinusIcon}
                        />
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
            {fieldsNumError && (
              <p className="so-input-error">Please enter a min 1 </p>
            )}
            {checkPreviousElement(fields) && fields.length < 6 && (
              <button className="tf-btn" onClick={(e) => handleAddField(e)}>
                <img className="add-remove-icon" src={AddPlusIcon} />
                Add
              </button>
            )}
          </div>
        </div>
      </SimpleForm>
    </Create>
  );
};

export default DiscountSchemesCreate;
